import "./_adresseSelect.scss";

import {useContext, useEffect, useState} from "react";

import iconUpdate from "@/assets/massification/iconUpdate.svg";
import iconValidate from "@/assets/massification/iconValidate.svg";
import Button from "@/components/Button/Button";
import SelectCustom from "@/components/SelectCustom/SelectCustom";
import {HookFormContext} from "@/context/HookFormContext";
import {findAdresse} from "@/function/engagementTools";
import {Adresse} from "@/ts/interface/compte";
import {OptionNameValue} from "@/ts/interface/formulaire";

function AdresseSelect({
  adressesList,
  nameFormChamp,
}: {
  adressesList: Adresse[];
  nameFormChamp: string;
}): JSX.Element | undefined {
  const context = useContext(HookFormContext);

  if (!context) {
    throw new Error("HookFormContext is not provided.");
  }
  const {watch, setValue} = context;
  const [isChangeMode, setIsChangeMode] = useState<boolean>(false);

  const adresseOption: OptionNameValue[] = adressesList.map(option => {
    return {
      libelle: (
        <>
          <span>{option.libelle}</span> <br />
          {option.value}
        </>
      ),
      value: option,
    };
  });

  const [currentAdresseLivraison, setCurrentAdresseLivraison] = useState<
    Adresse | undefined
  >(undefined);
  const [currentAdresseFacturation, setCurrentAdresseFacturation] = useState<
    Adresse | undefined
  >(undefined);

  // Watch les valeurs d'adresse_livraison_id et adresse_facturation_id
  const adresseLivraisonId = watch(`${nameFormChamp}.adresse_livraison_id`);
  const adresseFacturationId = watch(`${nameFormChamp}.adresse_facturation_id`);

  // Mettre à jour currentAdresseLivraison quand adresse_livraison_id change
  useEffect(() => {
    const updatedAdresseLivraison =
      findAdresse(adressesList, adresseLivraisonId) || adressesList[0];
    setCurrentAdresseLivraison(updatedAdresseLivraison);
  }, [adresseLivraisonId]);

  // Mettre à jour currentAdresseFacturation quand adresse_facturation_id change
  useEffect(() => {
    const updatedAdresseFacturation =
      findAdresse(adressesList, adresseFacturationId) || adressesList[0];
    setCurrentAdresseFacturation(updatedAdresseFacturation);
  }, [adresseFacturationId]);

  if (isChangeMode) {
    return (
      <>
        <div className="adresseSelect-adresse adresseSelect-adresse--update">
          <h6>Choisir une adresse de livraison</h6>
          <SelectCustom
            defaultValue={currentAdresseLivraison?.value || ""}
            options={adresseOption}
            handleSelect={(value: Adresse) => {
              setValue(
                `${nameFormChamp}.adresse_livraison_id`,
                value.adresse_id,
              );
            }}
            name={`${nameFormChamp}.adresse_livraison_id`}
          />
        </div>
        <div className="adresseSelect-adresse adresseSelect-adresse--update">
          <h6>Choisir une adresse de facturation</h6>
          <SelectCustom
            defaultValue={currentAdresseFacturation?.value || ""}
            options={adresseOption}
            handleSelect={(value: Adresse) => {
              setValue(
                `${nameFormChamp}.adresse_facturation_id`,
                value.adresse_id,
              );
            }}
            name={`${nameFormChamp}.adresse_facturation_id`}
          />
        </div>
        <Button
          variant={"validate"}
          label="Enregistrer les modifications "
          icon={iconValidate}
          onClick={() => {
            setIsChangeMode(false);
          }}
        />
      </>
    );
  } else {
    return (
      <>
        <div className="adresseSelect-adresse">
          <h6>Adresse de livraison</h6>
          <p className="adresseSelect-adresse--current">
            {currentAdresseLivraison?.value || ""}
          </p>
        </div>
        <div className="adresseSelect-adresse">
          <h6>Adresse de facturation</h6>
          <p className="adresseSelect-adresse--current">
            {currentAdresseFacturation?.value || ""}
          </p>
        </div>
        <Button
          variant={"secondary"}
          icon={iconUpdate}
          label="Changer d'adresse"
          onClick={() => setIsChangeMode(true)}
        />
      </>
    );
  }
}

export default AdresseSelect;
